'use client'

import { useMemo } from 'react'
import { type IStateResult, UsaStates } from 'usa-states'

import { Select } from '@/components/atomic/select'

interface StateSelectProps {
  value: string
  onValueChange: (value: string) => void
  label?: string
  disabled?: boolean
}

export function StateSelect({
  value,
  onValueChange,
  label,
  disabled = false,
}: StateSelectProps) {
  const stateOptions = useMemo(() => {
    const usaStates = new UsaStates({
      includeTerritories: true,
      contiguousOnly: false,
      exclude: [],
      ignoreCharacter: '$',
    }).states

    return usaStates.map((state: IStateResult) => ({
      label: state.name,
      value: state.abbreviation,
    }))
  }, [])

  return (
    <Select
      options={stateOptions}
      value={value}
      onValueChange={onValueChange}
      label={label}
      disabled={disabled}
    />
  )
}
